import gql from 'graphql-tag';
import { commentInfo, discussionInfo } from '@/store/forumAPI/utils/forum-fields';

export const createDiscussion = gql`
  mutation CreateDiscussionMutation($name: String, $text: String, $userId: Int!, $channelId: Int!, $attachments: [JSON!]!) {
    upsertDiscussion(
      data: {
        name: $name
        text: $text
        userId: $userId
        attachments: $attachments
        channelId: $channelId
      }
    ) {
      ${discussionInfo}
    }
  }
`;

export const createComment = gql`
  mutation createComment($text: String!, $discussionId: Int!, $userId: Int!, $attachments: [JSON!]!) {
    upsertComment(
      data: {
        text: $text,
        userId: $userId,
        attachments: $attachments,
        discussionId: $discussionId
      }
    ) {
      ${commentInfo}
    }
  }
`;

export const createCommentReply = gql`
  mutation createComment($text: String!, $quotedCommentId: Int!, $userId: Int!, $attachments: [JSON!]!) {
    upsertComment(
      data: {
        text: $text,
        userId: $userId,
        attachments: $attachments,
        quotedCommentId: $quotedCommentId
      }
    ) {
      ${commentInfo}
    }
  }
`;

export const updateCommentScoreById = gql`
  mutation updateCommentScoreById($commentId: Int!, $score: Float) {
    upsertComment(data: { id: $commentId, score: $score }) {
      ${commentInfo}
    }
  }
`;

export const deleteComment = gql`
  mutation deleteComment($commentId: Int!) {
    deleteComment(id: $commentId)
  }
`;

export const updateComment = gql`
  mutation updateComment($text: String!, $attachments: [JSON!]!, $commentId: Int!) {
    upsertComment(data: {
      id: $commentId
      text: $text
      attachments: $attachments,
    }) {
      ${commentInfo}
    }
  }
`;

export const deleteDiscussion = gql`
  mutation deleteDiscussion($discussionId: Int!) {
    deleteDiscussion(id: $discussionId)
  }
`;

export const updateDiscussion = gql`
  mutation updateDiscussion($text: String!, $attachments: [JSON!]!, $discussionId: Int!) {
    upsertDiscussion(data: {
      id: $discussionId
      text: $text,
      attachments: $attachments,
    }) {
      ${discussionInfo}
    }
  }
`;
